import React, { Component } from 'react';
import Sidebar from './Sidebar';
import Errors from '../../Errors';
import api from '../../../utils/api';
import withTranslations from '../../../utils/translations/withTranslations';

import Pilot from './Content/Pilot';
import HomeDoctor from './Content/HomeDoctor';
import BloodType from './Content/BloodType';
import Tetanus from './Content/Tetanus';
import Anamnese from './Content/Anamnese';
import SportAnamnese from './Content/SportAnamnese';
import UrineTest from './Content/UrineTest';
import ClinicalResearch from './Content/ClinicalResearch';
import Pneumones from './Content/Pneumones';
import Cor from './Content/Cor';
import BloodVessels from './Content/BloodVessels';
import MuscleMovementSystem from './Content/MuscleMovementSystem';
import Skeleton from './Content/Skeleton';
import NervousSystem from './Content/NervousSystem';
import DentalSystem from './Content/DentalSystem';
import EndocrineUrogenitalSystem from './Content/EndocrineUrogenitalSystem';
import DermatologistSystem from './Content/DermatologistSystem';
import AdditionalInvestigations from './Content/AdditionalInvestigations';
import Decision from './Content/Decision';
import Opinions from './Content/Opinions';
import Submit from './Content/Submit';
import Ergometertest from './Content/Ergometertest';

import './Fiche.css';

const STORAGE_KEY = 'fiche.data';
const HIDE_FROM_STORAGE_KEY = 'items';

class Fiche extends Component {
  constructor(...props) {
    super(...props);

    const storedData = window.localStorage.getItem(STORAGE_KEY);

    const state =
      storedData !== null
        ? JSON.parse(storedData)
        : {
            current: 'pilot',
            sidebar: {
              pilot: true
            },
            data: {},
            errors: undefined,
            success: false,
            code: 'XXXX'
          };

    state[HIDE_FROM_STORAGE_KEY] = this.getItems();

    this.state = state;
  }

  getItems() {
    return {
      pilot: Pilot,
      home_doctor: HomeDoctor,
      blood_type: BloodType,
      tetanus: Tetanus,
      anamnese: Anamnese,
      sport_anamnese: SportAnamnese,
      urine_test: UrineTest,
      clinical_research: ClinicalResearch,
      pneumones: Pneumones,
      cor: Cor,
      blood_vessels: BloodVessels,
      muscle_movement_system: MuscleMovementSystem,
      skeleton: Skeleton,
      nervous_system: NervousSystem,
      dental_system: DentalSystem,
      endocrine_urogenital_system: EndocrineUrogenitalSystem,
      dermatologist_system: DermatologistSystem,
      ergometertest: Ergometertest,
      additional_investigations: AdditionalInvestigations,
      decision: Decision,
      opinions: Opinions,
      submit: Submit
    };
  }

  next() {
    this.goTo(Object.keys(this.state.items)[this.currentIndex() + 1]);
  }

  previous() {
    this.goTo(Object.keys(this.state.items)[this.currentIndex() - 1]);
  }

  currentIndex() {
    const { items, current } = this.state;

    return Object.keys(items).indexOf(current);
  }

  save() {
    this.setState({ isBusy: true, errors: undefined });

    api
      .post('/auth/fiche', { body: this.state.data })
      .then(({ data }) => {
        window.localStorage.removeItem(STORAGE_KEY);

        this.setState({
          success: true,
          data: undefined,
          errors: undefined,
          code: data.code.toString()
        });
      })
      .catch(({ data: errors }) => this.setState({ errors, isBusy: false })); // TODO! hide button when busy
  }

  goTo(item) {
    // This means we reached the end and we will send the data to the server
    if (!item) {
      this.save();

      return;
    }

    this.setState(prevState => ({
      current: item,
      sidebar: {
        ...prevState.sidebar,
        [item]: true
      }
    }));
  }

  saveItem(data) {
    this.setState(
      prevState => ({
        data: {
          ...prevState.data,
          [prevState.current]: data
        }
      }),
      () => {
        window.localStorage.setItem(
          STORAGE_KEY,
          JSON.stringify(this.state, (key, value) => {
            return key === HIDE_FROM_STORAGE_KEY ? undefined : value;
          })
        );
      }
    );
  }

  render() {
    const { items, current, data, errors, success, code } = this.state;
    const { translate } = this.props;

    const ComponentToRender = items[current];

    if (success) {
      return (
        <div>
          <h1>{translate('fiche.success.title')}</h1>

          <p>{translate('fiche.success.body')}</p>

          <h3>{translate('fiche.success.code')}</h3>
          <p>{translate('fiche.success.code_explained')}</p>

          <div className="MedicalCode">
            <div className="MedicalCode__Number">{code.substring(0, 1)}</div>
            <div className="MedicalCode__Number">{code.substring(1, 2)}</div>
            <div className="MedicalCode__Number">{code.substring(2, 3)}</div>
            <div className="MedicalCode__Number">{code.substring(3, 4)}</div>
          </div>

          <h3>{translate('fiche.honorarium.title')}</h3>

          <ul style={{ listStyleType: 'disc', marginLeft: 20 }}>
            <li>{translate('fiche.honorarium.to_pay_1')}</li>
            <li>{translate('fiche.honorarium.to_pay_2')}</li>
          </ul>
        </div>
      );
    }

    return (
      <div className="Fiche">
        <Sidebar
          items={this.state.items}
          sidebar={this.state.sidebar}
          goTo={item => this.goTo(item)}
        />
        <div className="Fiche__Content">
          <Errors errors={errors} />
          <ComponentToRender
            next={() => this.next()}
            previous={() => this.previous()}
            saveItem={data => this.saveItem(data)}
            data={data[current]}
            allData={data}
          />
        </div>
      </div>
    );
  }
}

export default withTranslations(Fiche);
